import React from 'react'
import UserForm from '../components/userForm'
import Body from '../components/body'
import { SimpleSlider } from '../components/slider'
import Header from '../components/header'
// import Map from '../components/Map'


const Landing = () => {
    return (
        <div>
            <Header />
            <Body />
            <SimpleSlider />
            <UserForm />
            {/* <Map /> */}

            <div>
                <footer id="footer">
                    <div className="container-fluid">
                        <h3>Redes  Sociales</h3>
                        <i className="social-btn fab fa-facebook-f" />
                        <i className="social-btn fab fa-instagram" />
                        <i className="social-btn fab fa-envelope-o" />
                        <i className="fa fa-envelope-o" aria-hidden="true"/>

                    </div>
                </footer>
            </div>

        </div>
    )
}

export default Landing
